export default function HapusData() {
  return (
    <>
      <div className="container">
        <h3>Request Hapus Data</h3>
        <p>
          Jika anda ingin menghapus data yang terdapat pada Aplikasi Peduli TBC,
          silahkan isi form berikut.
        </p>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLScV323wTzLysqfpzdfFyLatMmYvwiVnvSGQRSox48rL2jFRCQ/viewform?embedded=true"
          width="640"
          height="693"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          data-aos="fade-up"
        >
          Memuat…
        </iframe>
      </div>
    </>
  );
}
